import { Box, Button, Grid } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import {
  Typography700,
  TourCardV2,
} from 'views/rebranded-module/common/components';
import StyledBox from 'views/rebranded-module/tours-module/TourViewV2/components/TourCardsSection/TourCardsSection.styles';
import NavigatorLink from 'views/rebranded-module/common/components/Logical/NavigatorLink';
import PATHS from 'lib/navigation/paths';

const TourCardsSection = (props) => {
  const { cmsData, relatedTours } = props;
  const { deviceType } = useSelector((state) => state.globalData);
  return (
    <StyledBox>
      <Box className="TSHeader">
        <Box>
          <Typography700 component="p" variant="h5">
            {cmsData.TourDetailsPage.mightLike}
          </Typography700>
          {/* <Typography variant="body1" component="p">
            {cmsData.TourDetailsPage.exploreAllTours}
          </Typography> */}
        </Box>
        <Button
          variant="contained"
          color="primary"
          size="large"
          component={NavigatorLink}
          href={PATHS.motorcycleTours.listing()}>
          {cmsData.TourDetailsPage.exploreAllTours}
        </Button>
      </Box>
      <Grid container rowSpacing={3} columnSpacing={2}>
        {relatedTours
          .slice(0, ['tablet', 'mobile'].includes(deviceType) ? 4 : 5)
          .map((tour) => (
            <Grid
              item
              xxl={2.4}
              xl={3}
              lg={6}
              md={6}
              sm={12}
              key={tour.name}
              className="TCSTourCardContainer">
              <TourCardV2
                tour={tour}
                content={cmsData.TourCardComponent}
                showCarousel
              />
            </Grid>
          ))}
      </Grid>
    </StyledBox>
  );
};

export { TourCardsSection };
